var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "internal-page-main-section col-xs-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "survey-main-section col-xs-12 float-l" }, [
            _c("div", {}, [
              _c("div", {}, [
                _c(
                  "form",
                  {
                    attrs: {
                      id: "categorieForm",
                      method: "POST",
                      enctype: "multipart/form-data"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "mediaCaption" } }, [
                            _vm._v("Image Caption")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-line" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mediaCaption,
                                  expression: "mediaCaption"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                maxlength: "190",
                                type: "text",
                                id: "mediaCaption",
                                name: "mediaCaption",
                                placeholder: "Enter Image Caption"
                              },
                              domProps: { value: _vm.mediaCaption },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.mediaCaption = $event.target.value
                                }
                              }
                            })
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      },
                      [
                        [
                          _c(
                            "div",
                            { attrs: { id: "app" } },
                            [
                              _c("vue-dropzone", {
                                ref: "dropzone",
                                attrs: {
                                  id: "drop1",
                                  options: _vm.dropzoneOptions,
                                  destroyDropzone: false,
                                  headers: _vm.dropzoneOptions.headers,
                                  name: "file"
                                },
                                on: {
                                  "vdropzone-removed-file":
                                    _vm.removedSelectedFile,
                                  "vdropzone-success": _vm.vfileSuccess,
                                  "vdropzone-duplicate-file":
                                    _vm.vduplicateFile,
                                  "vdropzone-total-upload-progress":
                                    _vm.progressOfUload
                                }
                              }),
                              _vm._v(" "),
                              _c("font", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.cropError))
                              ])
                            ],
                            1
                          )
                        ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("br")
                  ]
                ),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: {
                          id: "addMedia",
                          type: "submit",
                          value: "Save"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.saveMediaDetail()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { id: "removeAll" },
                          on: { click: _vm.removeAllFiles }
                        },
                        [_vm._v("Clear Image")]
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "internal-page-banner-main col-xs-12" },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "page-title" }, [
              _c("h1", [_vm._v("Add Image For Gallery")])
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c("div", { staticClass: "alert", attrs: { id: "alertError" } }, [
          _c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25e67c7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e67c7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddPhoto.vue
// module id = null
// module chunks = 